const rankingItems = [
  { rank: 1, title: '狂飙', category: '国产剧', hot: '9.8', tag: '热播中', tagColor: 'primary' as const },
  { rank: 2, title: '漫长的季节', category: '国产剧', hot: '9.7', tag: '高分', tagColor: 'accent' as const },
  { rank: 3, title: '三体', category: '科幻剧', hot: '9.6', tag: '热播中', tagColor: 'primary' as const },
  { rank: 4, title: '莲花楼', category: '古装剧', hot: '9.5', tag: '新上', tagColor: 'secondary' as const },
  { rank: 5, title: '封神第一部', category: '电影', hot: '9.4', tag: '院线', tagColor: 'accent' as const },
  { rank: 6, title: '长相思', category: '古装剧', hot: '9.3', tag: '热播中', tagColor: 'primary' as const },
];

const tagStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const rankStyles = ['text-primary-500', 'text-accent-500', 'text-secondary-500'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              热播排行
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              本周最受观众欢迎的影视作品
            </p>
          </div>

          <div className="max-w-2xl mx-auto space-y-3">
            {rankingItems.map((item, idx) => (
              <div
                key={item.title}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <span className={`text-2xl font-bold font-heading w-8 text-center ${
                  idx < 3 ? rankStyles[idx] : 'text-foreground-400'
                }`}>
                  {String(item.rank).padStart(2, '0')}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagStyles[item.tagColor]}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                  <span className="text-sm font-semibold text-accent-600">{item.hot}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}